// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3AagJ","col":"styles_col__2OkZk"};